<template>
  <div class="machine-monitor-wrap">
    <!-- 顶部标题栏 -->
    <div class="top-header">
      <div class="header-left">
        <span class="tag-btn"> <img src="../assets/img/start-top.png" alt="">{{ form.state === 0 ? '待机' : form.state === 1 ? '运行中' : '未开机' }}</span>
      </div>
      <div class="header-title">{{ form.name }}</div>
      <div class="header-time"><img src="../assets/img/time-top.png" alt=""> {{ form.date }}</div>
    </div>

    <div class="main-content">
      <!-- 左侧印刷速度大面板 -->
      <div class="speed-card">
        <div class="card-title">印刷速度（张/时）</div>
        <div class="speed-num">{{ serialData === "等待串口数据…" ? '--' : serialData }}</div>
      </div>

      <!-- 右侧参数信息区 -->
      <div class="right-info-group">
        <!-- 第一块：水质参数 -->
        <div class="info-card water-card"  :class="{ warningBorder: isAnyOverLimit }">
          <div class="info-item">
            <span class="label"><img src="@/assets/img/icon-c.png" class="ddl" alt=""> 电导率:</span>
            <span class="value"  :class="{
         warning: isDdlOver,
      normal: !isDdlOver
      }">{{ form.state !== -2 ? (form.ddl ? form.ddl + 'μS/cm' : '-' + 'μS/cm') : '-'  + 'μS/cm'}}</span>
          </div>
          <div class="info-item">
            <span class="label"><img src="@/assets/img/icon-ph.png" alt=""> PH值:</span>
            <span class="value" :class="{
       warning: isPhOver,
      normal: !isPhOver
      }">{{ form.state !== -2 ?( form.ph ? form.ph : '-') : '-' }}</span>
          </div>
          <div class="info-item">
            <span class="label"><img src="@/assets/img/icon-t.png" alt=""> 水温:</span>
            <span class="value"
                  :class="{
       warning: isWdOver,
      normal: !isWdOver
      }">{{ form.state !== -2 ? (form.wd ? form.wd + '℃' : '-' + '℃') : '-' + '℃' }}</span>
          </div>
        </div>

        <!-- 第二块：当日生产数据 -->
        <div class="info-card water-card">
          <div class="info-item">
            <span class="label"><img src="@/assets/img/icon-number.png" alt=""> 日印刷数:</span>
            <span class="value">{{ dayPrintCount }}</span>
          </div>
          <div class="info-item">
            <span class="label"><img src="@/assets/img/yinshu.png" alt=""> 日试印数:</span>
            <span class="value">{{ form.noCount }}</span>
          </div>
          <div class="info-item">
            <span class="label"><img src="@/assets/img/icon-item.png" alt=""> 日开机时长:</span>
            <span class="value">{{ form.time }}</span>
          </div>
        </div>

        <!--        &lt;!&ndash; 第三块：温湿度 &ndash;&gt;-->
        <!--        <div class="info-card">-->
        <!--          <div class="info-item">-->
        <!--            <span class="label">🌡️ 室内温度:</span>-->
        <!--            <span class="value">25.5</span>-->
        <!--          </div>-->
        <!--          <div class="info-item">-->
        <!--            <span class="label">💦 室内湿度:</span>-->
        <!--            <span class="value">60.5</span>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>

    <!-- 底部四栏信息 -->
    <div class="bottom-row">
      <!-- 设备规格 -->
      <div class="bottom-card">
        <div class="spec-item">最小印刷幅面 &nbsp;<span class="blue-text">{{ form.minPrintWidth }}x{{ form.minPrintHeight }}mm</span></div>
        <div class="spec-item">最大印刷幅面 &nbsp;<span class="blue-text">{{ form.maxPrintWidth }}x{{ form.maxPrintHeight }}mm</span></div>
        <div class="spec-item">承印纸张厚度 &nbsp;<span class="blue-text">{{ form.minPaperThickness }}-{{ form.maxPaperThickness }}mm</span></div>
        <div class="spec-item">最高印刷速度 &nbsp;<span class="blue-text">{{ form.maxSpeed }}张/小时</span></div>
      </div>
      <!-- 机台负责人 -->
      <div class="bottom-card person-card">
        <div class="card-subtitle">机台负责人</div>
        <div class="person-name">{{ form.person ? form.person : '-' }}</div>
      </div>
      <!-- 保养提醒 -->
      <div class="bottom-card maintain-card">
        <div class="card-subtitle">保养提醒</div>
        <div class="notab" v-if="form.maintainList.length < 1">暂无数据</div>
        <div class="maintain-tabs">
          <span
              class="tab"
              :class="{ active: form.noMaintainList.includes(item) }"
              v-for="item in form.maintainList"
              :key="item"
          >
            {{ maintainMap[item] || item }}
          </span>

        </div>
      </div>
      <!-- 温湿度复用面板 -->
      <div class="bottom-card temp-hum-card">
        <div class="info-item">
          <span class="label"><img src="@/assets/img/snwd.png" alt=""> 室内温度:</span>
          <span class="value">{{ form.state !== -2 ? (form.temperature ? Number(form.temperature).toFixed(1) + '℃' : '-' + '℃' ) : '-' + '℃'}}</span>
        </div>
        <div class="info-item">
          <span class="label"><img src="@/assets/img/snsd.png" alt=""> 室内湿度:</span>
          <span class="value">{{ form.state !== -2 ? (form.humidity ? Number(form.humidity).toFixed(1) + '%' : '-' + '%') : '-' + '%' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
export default {
  name: 'PrintMachineMonitor',
  data() {
    return {
      maintainMap: {
        1: '日',
        2: '周',
        3: '月',
        4: '季',
        5: '半年',
        6: '年',
        30: '半月'
      },
      form: {
        date: '',
        maintainList: [],     // 所有保养项：['日','周','月','半月','季','年']
        noMaintainList: [],    // 未保养项：['月','半月']
        serverVersion: 0, // 后端返回服务端版本号
      },
      serverVersion:1,
      timer: null, // 定时器
      timerData: null,   // 接口刷新定时器
      lastDateTime: 0,    // 接口返回的时间戳（毫秒）
      serialData: '等待串口数据…',
      serialDataC: '等待串口数据…',
      // 保存上一次有效 c 值
      lastValidC: null,
      serialTs: 0,
      count:'',
      baseAllCount: 0, // 新增：接口返回的基准总数
      // 新增：串口超时计时器
      serialTimeoutTimer: null,
      // 用于锁定上限
      cLocked: false,
    }
  },
  computed: {
    isDdlOver() {
      const { ddl, electricityDown, electricityUp } = this.form
      if (!ddl || electricityDown == null || electricityUp == null) return false
      return ddl < electricityDown || ddl > electricityUp
    },
    isPhOver() {
      const { ph, phDown, phUp } = this.form
      if (!ph || phDown == null || phUp == null) return false
      return ph < phDown || ph > phUp
    },
    isWdOver() {
      const { wd, temperaturDown, temperaturUp } = this.form
      if (!wd || temperaturDown == null || temperaturUp == null) return false
      return wd < temperaturDown || wd > temperaturUp
    },
    isAnyOverLimit() {
      return this.isDdlOver || this.isPhOver || this.isWdOver
    },
    // 日印刷数
    dayPrintCount() {
      const v = Number(this.serialDataC)
      if (isNaN(v) || this.serialDataC === '等待串口数据…') {
        return this.baseAllCount
      }
      // 超过上限后，保持最后一次有效值，不再变化
      // if (this.cLocked) {
      //   return Math.max(0, v - this.baseAllCount)
      // }
      return Math.max(0, v - this.baseAllCount)
    },
  },
  mounted() {
    window.onSerialData = this.handler
    this.getDaPingJiTaiYuTong()
    this.timerData = setInterval(() => {
      this.getDaPingJiTaiYuTong()
    }, 15000) // 10 秒
    this.timerData = setInterval(() => {
      this.DaPingVersion()
    }, 1000 * 20) // 10 秒
    // 每秒刷新一次时间
    this.timer = setInterval(() => {
      this.addOneSecond()
    }, 1000)
  },

  beforeDestroy() {
    delete window.onSerialData
    // 页面销毁清除定时器
    clearInterval(this.timer)
    clearInterval(this.timerData)
    // 清除串口超时计时器
    if (this.serialTimeoutTimer) {
      clearTimeout(this.serialTimeoutTimer)
    }
  },
  methods: {
    // 版本号比较工具函数
    compareVersion(v1, v2) {
      const arr1 = v1.split('.').map(Number)
      const arr2 = v2.split('.').map(Number)
      const maxLen = Math.max(arr1.length, arr2.length)
      for (let i = 0; i < maxLen; i++) {
        const num1 = arr1[i] || 0
        const num2 = arr2[i] || 0
        if (num1 > num2) return 1
        if (num1 < num2) return -1
      }
      return 0
    },
    handler(payload) {
      // 清除之前的超时计时器
      if (this.serialTimeoutTimer) {
        clearTimeout(this.serialTimeoutTimer)
      }

      let item
      // 判断是数组取最后一项；是对象直接用；其它直接返回
      if (Array.isArray(payload)) {
        if (payload.length === 0) return
        item = payload.at(-1)
      } else {
        item = payload
      }

      // 防御：item不存在或者没有v/c字段直接退出
      if (!item || item.v === undefined || item.c === undefined) {
        return
      }

      const v = Number(item.v) // 速度
      if (v <= 99999) {
        this.serialData = item.v
      }
      const currentC = Number(item.c) // 日印刷数

      // ===================== 核心跳变校验逻辑不变 =====================
      if (!isNaN(currentC)) {
        if (this.lastValidC == null) {
          // 第一次：直接赋值
          this.serialDataC = currentC
          this.lastValidC = currentC
        } else {
          // 比上次大100倍或者变小，丢弃
          if (currentC >= this.lastValidC * 100 || currentC < this.lastValidC) {
            console.log('数据异常（跳变/减小），丢弃：', currentC, '保留：', this.lastValidC)
          } else {
            this.serialDataC = currentC
            this.lastValidC = currentC
          }
        }
      }

      // 12秒没有新数据，速度置0
      this.serialTimeoutTimer = setTimeout(() => {
        // this.serialData = 0
        this.serialData = '--'
      }, 5000) // 12000

      console.log(this.serialData, this.serialTs, '--------2')
    },
    getDaPingJiTaiYuTong() {
      console.log(this.$route.query.deviceId)
      API.DaPingJiTaiYuTong({deviceId: this.$route.query.deviceId,}).then(res => {
        console.log(res)
        this.form = res.message.data
        this.baseAllCount = res.message.data.allCount || 0 // 保存基准
        if (this.form.maintainList && this.form.maintainList.length) {
          this.form.maintainList.sort((a, b) => a - b)
        }
        console.log(this.form)
        if (this.form.date) {
          this.lastDateTime = new Date(this.form.date).getTime()
        }
      })

    },
    DaPingVersion() {
      API.getDaPingVersion({type:'ShiShiSuDuDaPingNew'}).then(res =>{
        console.log(res,'---')
        // this.serverVersion = res.message.data

        const apiVer = Number(res.message.data)
        const localBaseVer = this.serverVersion
        console.log(apiVer,localBaseVer,'---')
        if (apiVer !== localBaseVer) {
          console.log(`版本不一致，基准:${localBaseVer} 接口返回:${apiVer}，准备清缓存刷新`)
          localStorage.setItem('lcd_server_version', apiVer)
          try {
            window.LcdBridge.clearCacheAndReload()
          } catch (e) {
            console.warn('LcdBridge调用失败，浏览器环境', e)
          }
        }
      })
    },
    formatSpeed(speed) {
      const num = Number(speed)
      if (isNaN(num)) return '-'
      // 等于0直接返回0
      if (num === 0) return 0
      // 否则抹掉后两位
      return Math.floor(num / 100) * 100
    },
    // 每秒 +1 秒并格式化
    addOneSecond() {
      if (!this.lastDateTime) return
      // 加 1000 毫秒
      this.lastDateTime += 1000
      // 格式化为 2026-06-13 15:09:36
      this.form.date = this.formatDate(new Date(this.lastDateTime))
    },

    // 日期格式化
    formatDate(date) {
      const y = date.getFullYear()
      const m = this.addZero(date.getMonth() + 1)
      const d = this.addZero(date.getDate())
      const h = this.addZero(date.getHours())
      const min = this.addZero(date.getMinutes())
      const s = this.addZero(date.getSeconds())
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    // 补零
    addZero(num) {
      return num < 10 ? '0' + num : num
    },
    currentTime(){
      setInterval(()=>{
        this.getDaPingJiTaiYuTong()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
}
.machine-monitor-wrap {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #d7e8ff 0%, #f0f5fb 100%);
}
// 顶部标题栏
.top-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 20px 18px;
  background-image: url("~@/assets/img/monitor.png");
  background-size: 100% 100%;
  position: relative;
  .tag-btn {
    font-size: 32px;
    //font-weight: 500;
    position: absolute;
    left: 50px;
    top: 10px;
    img {
      width: 24px;
      margin-right: 15px;
    }
  }
  .header-title {
    font-size: 54px;
    font-weight: bold;
    color: #004099;
  }
  .header-time {
    font-size: 32px;
    color: #333;
    position: absolute;
    top: 20px;
    right: 30px;
    img {
      width: 24px;
      margin-right: 20px;
    }
  }
}
// 主体区域
.main-content {
  display: flex;
  gap: 16px;
  padding: 16px;

  flex: 1;
  .speed-card {
    margin-right: 16px;
    flex: 1;
    border-radius: 6px;
    padding: 24px 0;
    border: 1px solid #fff;
    background: linear-gradient(180deg, #c6deff 0%, #f2f7fe 100%);
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
    .card-title {
      font-size: 50px;
      color: #222;
      margin-bottom: 30px;
    }
    .speed-num {
      font-size: 410px;
      font-weight: bold;
      color: #1677ff;
      line-height: 1;
      text-align: center;
    }
  }
  .right-info-group {
    width: 30%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    .info-card {
      background: #fff;
      border: 1px solid #fff;
      border-radius: 6px;
      padding: 16px 20px;
      flex: 1;
      background: linear-gradient(180deg, #d7e8ff 0%, #f0f5fb 100%);
      box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
      .info-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 22px;
        margin: 12px 0;
        .label {
          color: #333;
          font-size: 40px;
        }
        .value {
          font-size: 44px;
          font-weight: bold;
          color: #1677ff;
          width: 40%;
        }
        img{
          width: 30px;
        }
        .ddl {
          width: 24px;
        }
      }
    }
    .water-card {
      display: flex;
      flex-direction: column;
      padding: 16px 20px;
      .info-item {
        flex: 1; /* 三个item平分高度 */
        margin: 0; // 取消原来上下margin，避免间隙不均
      }
    }
  }
}
// 底部四栏
.bottom-row {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.6fr;
  gap: 16px;
  padding: 0 16px 16px;
  padding-bottom: 8px;
  .bottom-card {
    background: #fff;
    border: 1px solid #fff;
    border-radius: 6px;
    padding: 20px;
    background: linear-gradient(0deg, #d7e8ff 0%, #f0f5fb 100%);
    box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    .card-subtitle {
      font-size: 40px;
      margin-bottom: 16px;
      color: #222;
    }
  }
  // 设备规格栏
  .spec-item {
    font-size: 32px;
    margin: 16px 0;
    display: flex;
    //justify-content: space-between;
    align-items: center;
    .blue-text {
      color: #1677ff;
      font-weight: 500;
      //font-size: 32px;
    }
  }
  .spec-item:first-child{
    margin-top: 4px;
  }
  // 负责人
  .person-card {
    display: flex;
    flex-direction: column;
    //justify-content: center;
    align-items: center;
    .person-name {
      font-size: 48px;
      color: #1677ff;
      font-weight: bold;
      //line-height: 3;
    }
  }
  // 保养标签
  .maintain-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    //justify-content: center;
    .maintain-tabs {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      gap: 8px;
      margin-top: 18px;
      .tab {
        width: 100px;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 44px;
        border-radius: 4px;
        color: #146BF8;
      }
      .tab.active {
        background: #1677ff;
        color: #fff;
      }

      .year-tab {
        grid-column: 3;
        grid-row: 2;
      }
    }
    .notab {
      font-size: 28px;
      color: #146BF8;
      //margin-top: 60px;
      //width: 100px;
    }
  }
  // 底部温湿度
  .temp-hum-card {
    display: flex;
    flex-direction: column;
    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 20px;
      margin: 16px 0;
      flex: 1;
      .label {
        color: #333;
        font-size: 40px;
      }
      .value {
        font-size: 44px;
        font-weight: bold;
        color: #1677ff;
        width: 35%;
      }
      img{
        width: 30px;
      }
    }
  }
}
/* 正常范围内颜色 #4D87F8 */
.normal {
  color: #4D87F8!important;
}

/* 超出上下限颜色 #FA5744 */
.warning {
  color: #FA5744 !important;
}
/* 闪动红边框 */
.warningBorder {
  border: 2px solid #f81d04;
  animation: warningFlashIn 0.5s
  infinite alternate ease-in-out;
}

@keyframes warningFlashIn {
  0% {
    border-color: #fa5744;
    box-shadow: inset 0 0 6px 2px rgba(250, 87, 68, 0.5);
  }
  100% {
    border-color: #f81d04;
    box-shadow: inset 0 0 80px 6px rgb(234, 28, 4);
  }
}
</style>
